import React from "react";
import moment from "moment";

// Helper function to decode HTML entities
const decodeHtmlEntities = (text) => {
	const textArea = document.createElement('textarea');
	textArea.innerHTML = text;
	return textArea.value;
};

/**
 * -Menu-
 * Menu component that acts as a homepage for both mobile and desktop
 **/
class HeaderNav extends React.Component {
	render() {
		return (
			<ul>
				{ this.props.menus &&
					this.props.menus.map((item, i) => (
						<ListItem
							key={ i }
							text={ item.text }
							url={ item.url }
							children={ item.children }
							subMenuOpenHandler={ this.subMenuOpenHandler }
							i={ i }
						/>
					)) }
			</ul>
		);
	}
}

const ListItem = ({
	text,
	url,
	children,
	subMenuOpenHandler,
	subMenuClick,
	i,
}) => {
	let menuItem = (
		<li className="sub-menu-link">
			<a href={ url }> { decodeHtmlEntities(text) } </a>
		</li>
	);

	if (children) {
		menuItem = (
			<li className="sub-menu-item" role="presentation">
				<button
					className={ `sub-menu-btn sub-menu-btn--${ i } js-sub-menu-open` }
					type="button"
					aria-haspopup="true"
					aria-expanded="false"
					data-sub-menu-select={ i }
				>
					<span role="presentation">
						{ decodeHtmlEntities(text) }{ " " }
						<svg focusable="false" aria-hidden="true">
							<use xlinkHref="#arrow-small-down-w"></use>
						</svg>
					</span>
				</button>
				<nav
					className="sub-menu-collection sub-menu-collection--desktop"
					aria-hidden="false"
				>
					{ children &&
						children.map((item, i) => (
							<SubMenu
								key={ i }
								subMenuText={ item.text }
								subMenuUrl={ item.url }
								subMenuChildren={ item.children }
							/>
						)) }
				</nav>
			</li>
		);
	}

	return menuItem;
};

const SubMenu = ({ subMenuText, subMenuChildren }) => {
	const link = subMenuText === "Upcoming Events" ? "events" : "news";

	return (
		<div className="sub-menu-collection__child">
			<div id={ subMenuText + "NavLabel" } className="sub-nav-heading">
				{ decodeHtmlEntities(subMenuText) }
			</div>
			<ul aria-labelledby={ subMenuText + "NavLabel" }>
				{ subMenuChildren &&
					subMenuChildren.map((item, i) => (
						<SubMenuItem
							key={ i }
							text={ item.text }
							url={ item.url }
							children={ item.children }
							dateTime={ item.datetime }
							subMenu={ subMenuText }
						/>
					)) }
			</ul>

			{ (subMenuText === "Latest News" || subMenuText === "Upcoming Events") && (
				<a
					href={ `${ window.WEBSITE_ROOT }/${ link }/` }
					className="notification__button"
				>
					<span>View all { link }</span>
				</a>
			) }
		</div>
	);
};

const SubMenuItem = ({ text, url, subMenu, dateTime }) => {
	let linkContent = `${ decodeHtmlEntities(text) }
				<svg focusable="false" aria-hidden="true">
						<use xlinkHref="#arrow-small-down-w"></use>
				</svg>`;

	if (subMenu === "Latest News" || subMenu === "Upcoming Events") {
		linkContent += `<span className="srt">published on ${ moment(
			dateTime
		).format(
			"Do MMMM YYYY"
		) }</span><time aria-hidden="true" className="u-t-xsm u-t-sm-md" datetime="${ dateTime }">${ moment(
			dateTime
		).format("Do MMMM YYYY") }</time>`;
	}

	return (
		<li>
			<a
				href={ url }
				className="js-sub-menu-link"
				dangerouslySetInnerHTML={ { __html: linkContent } }
			></a>
		</li>
	);
};

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/HeaderNav.js